







// before 20-5-2026
// ===============================
// // =======================================
// import React, { useEffect, useState } from 'react';
// import { Modal, Button, Form, Row, Col, Card } from 'react-bootstrap';
// import { useDispatch, useSelector } from 'react-redux';
// import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
// import { AssignLeadsMarketerAndAdminAction } from '../Redux/Actions/UsersAction';
// import { Notify } from '../Utility/Notify';
// import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';
// import { FaUserTie, FaUsers, FaHistory, FaEyeSlash } from 'react-icons/fa';
// import Select from 'react-select'; // ✅ إضافة react-select

// const chunkArray = (array, size) => {
//   const chunked = [];
//   for (let i = 0; i < array.length; i += size) {
//     chunked.push(array.slice(i, i + size));
//   }
//   return chunked;
// };

// export const AssignLeadsModal = ({ show, onHide, selectedLeads = [], refreshData }) => {
//   const dispatch = useDispatch();

//   const [selectedOption, setSelectedOption] = useState('option1');
//   const [selectedStage, setSelectedStage] = useState(null);
//   const [userlogin, setuserlogin] = useState('');
//   const [salesname, setsalesname] = useState('');
//   const [selectedSalesDataArray, setSelectedSalesDataArray] = useState([]);
//   const [clearHistory, setClearHistory] = useState(false);
//   const [hideCreationDate, setHideCreationDate] = useState(false);
//   const [loading, setloading] = useState(true);
//   const [sendloading, setsendloading] = useState(false);
//   const [transferstorage, settransferstorage] = useState('');
//   const [assignType, setAssignType] = useState('salesman');

//   const leadsall = React.useMemo(() => {
//     console.log('selectedLeads:', selectedLeads);
//     const leads = selectedLeads.length > 0
//       ? selectedLeads
//       : JSON.parse(localStorage.getItem('selectedleeds') || '[]');
//     console.log('leadsall:', leads);
//     return leads;
//   }, [show, selectedLeads]);

//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem('user') || '{}');
//     setuserlogin(user);
//     settransferstorage(localStorage.getItem('action') || '');
//   }, []);

//   useEffect(() => {
//     const getData = async () => {
//       await dispatch(Get_All_Sales_Action());
//       await dispatch(GetAll_stage_Data());
//     };
//     getData();
//   }, [dispatch]);

//   const resSalesData = useSelector((state) => state.AllSales.sales?.data || []);
//   const resStagesData = useSelector((state) => state.Allstages.stage?.data || []);
//   const freshStage = resStagesData.find((stage) => stage.name === 'No Stage');

//   // ✅ تحويل بيانات الـ sales إلى الشكل المناسب لـ react-select
//   const salesOptions = React.useMemo(() => {
//     const filtered = assignType === 'teamLeader'
//       ? resSalesData.filter((sales) => sales?.userlog?.role === 'Team Leader')
//       : resSalesData;
    
//     return filtered.map(sale => ({
//       value: sale._id,
//       label: `${sale.name} ${sale.userlog?.role ? `(${sale.userlog.role})` : ''}`,
//       original: sale
//     }));
//   }, [resSalesData, assignType]);

//   const handleClose = () => {
//     setSelectedSalesDataArray([]);
//     setsalesname('');
//     setSelectedStage(null);
//     setSelectedOption('option1');
//     setClearHistory(false);
//     setHideCreationDate(false);
//     setAssignType('salesman');
//     onHide();
//   };

//   const stagechange = (e) => {
//     const selectedId = e.target.value;
//     const selected = resStagesData.find(stage => stage._id === selectedId);
//     setSelectedStage(selected || null);
//   };

//   // ✅ تحديث دالة اختيار الـ sales مع react-select
//   const onsaleschange = (selectedOption) => {
//     if (selectedOption) {
//       setsalesname(selectedOption.value);
//       setSelectedSalesDataArray([selectedOption.original]);
//     } else {
//       setsalesname('');
//       setSelectedSalesDataArray([]);
//     }
//   };

//   const senddleedtosalesaction = async (e) => {
//     e.preventDefault();
//     if (!salesname) return Notify('error', 'Please select sales', 'error');
//     if (leadsall.length === 0) return Notify('error', 'No leads selected', 'error');

//     setloading(true);
//     setsendloading(true);

//     try {
//       const assignTypeBoolean = assignType === 'teamLeader';

//       let stageValue = null;

//       if (transferstorage === 'Transfer') {
//         if (freshStage?._id) {
//           stageValue = freshStage._id;
//         } else {
//           Notify('error', 'Failed. Try Again', 'error');
//           return;
//         }
//       }

//       if (selectedOption === 'option2' && selectedStage?._id) {
//         stageValue = selectedStage._id;
//       }

//       const leadChunks = chunkArray(leadsall, 10);

//       for (const chunk of leadChunks) {
//         await Promise.all(
//           chunk.map(async (leadId) => {
//             return await dispatch(
//               AssignLeadsMarketerAndAdminAction(
//                 leadId,
//                 userlogin?.data?._id,
//                 salesname,
//                 clearHistory,
//                 stageValue,
//                 assignTypeBoolean,
//                 hideCreationDate,
//               ),
//             );
//           }),
//         );
//       }

//       if (transferstorage === 'Transfer') {
//         localStorage.removeItem('action');
//         settransferstorage('');
//       }

//       Notify(
//         'success',
//         `Leads assigned successfully as ${assignType === 'teamLeader' ? 'Team Leader' : 'Salesman'}`,
//         'success',
//       );
      
//       handleClose();
//       refreshData?.();
//     } catch (err) {
//       console.error('❌ Error in assignment:', err);
//       Notify('error', 'Failed to assign leads', 'error');
//     } finally {
//       setloading(false);
//       setsendloading(false);
//     }
//   };

//   // ✅ styles مخصصة لـ react-select عشان تتناسب مع التصميم
//   const customSelectStyles = {
//     control: (provided, state) => ({
//       ...provided,
//       borderRadius: '8px',
//       padding: '2px',
//       borderColor: state.isFocused ? '#102dff' : '#dee2e6',
//       boxShadow: state.isFocused ? '0 0 0 1px #102dff' : 'none',
//       '&:hover': {
//         borderColor: '#102dff',
//       },
//     }),
//     option: (provided, state) => ({
//       ...provided,
//       backgroundColor: state.isSelected ? '#102dff' : state.isFocused ? '#f0f7ff' : 'white',
//       color: state.isSelected ? 'white' : '#495057',
//       cursor: 'pointer',
//       '&:active': {
//         backgroundColor: '#102dff',
//       },
//     }),
//     menu: (provided) => ({
//       ...provided,
//       zIndex: 9999, // ✅ عشان يظهر فوق كل حاجة
//       borderRadius: '8px',
//       boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//     }),
//     menuPortal: (provided) => ({
//       ...provided,
//       zIndex: 9999,
//     }),
//     placeholder: (provided) => ({
//       ...provided,
//       color: '#6c757d',
//     }),
//   };

//   return (
//     <Modal
//       show={show}
//       onHide={handleClose}
//       size="lg"
//       centered
//       backdrop="static"
//       className="assign-leads-modal"
//     >
//       <Modal.Header
//         closeButton
//         style={{
//           backgroundColor: '#f8f9fa',
//           borderBottom: '1px solid #e9ecef',
//           padding: '1.5rem',
//         }}
//       >
//         <Modal.Title
//           style={{
//             color: '#102dff',
//             fontWeight: '600',
//             fontSize: '1.5rem',
//           }}
//         >
//           <FaHistory style={{ marginRight: '10px', marginBottom: '5px' }} />
//           Assign Leads to Sales
//         </Modal.Title>
//       </Modal.Header>

//       <Modal.Body style={{ padding: '1.5rem' }}>
//         {/* Selected Leads Info */}
//         <Card
//           className="mb-4"
//           style={{
//             backgroundColor: '#f0f7ff',
//             border: 'none',
//             borderRadius: '10px',
//           }}
//         >
//           <Card.Body className="py-3">
//             <div className="d-flex align-items-center justify-content-between">
//               <div className="d-flex align-items-center">
//                 <span style={{ fontSize: '1.2rem', marginRight: '10px' }}>📋</span>
//                 <span style={{ fontWeight: '600', color: '#102dff' }}>Selected Leads</span>
//               </div>
//               <span
//                 style={{
//                   backgroundColor: '#102dff',
//                   color: 'white',
//                   padding: '4px 12px',
//                   borderRadius: '20px',
//                   fontSize: '0.9rem',
//                   fontWeight: '600',
//                 }}
//               >
//                 {leadsall.length} Lead{leadsall.length !== 1 ? 's' : ''}
//               </span>
//             </div>
//           </Card.Body>
//         </Card>

//         {/* Assignment Type */}
//         <h6
//           style={{
//             color: '#495057',
//             fontWeight: '600',
//             marginBottom: '15px',
//           }}
//         >
//           Assignment Type
//         </h6>

//         <Row className="mb-4">
//           <Col md={6}>
//             <Card
//               onClick={() => setAssignType('salesman')}
//               style={{
//                 cursor: 'pointer',
//                 border: assignType === 'salesman' ? '2px solid #102dff' : '1px solid #dee2e6',
//                 backgroundColor: assignType === 'salesman' ? '#f0f7ff' : 'white',
//                 borderRadius: '10px',
//                 transition: 'all 0.2s ease',
//               }}
//               className="h-100"
//             >
//               <Card.Body className="text-center py-4">
//                 <FaUserTie
//                   style={{
//                     fontSize: '2rem',
//                     color: assignType === 'salesman' ? '#102dff' : '#6c757d',
//                     marginBottom: '10px',
//                   }}
//                 />
//                 <h6
//                   style={{
//                     fontWeight: '600',
//                     color: assignType === 'salesman' ? '#102dff' : '#495057',
//                   }}
//                 >
//                   Assign as Salesman
//                 </h6>
//                 <small style={{ color: '#6c757d' }}>Assign leads to individual sales</small>
//               </Card.Body>
//             </Card>
//           </Col>

//           <Col md={6}>
//             <Card
//               onClick={() => setAssignType('teamLeader')}
//               style={{
//                 cursor: 'pointer',
//                 border: assignType === 'teamLeader' ? '2px solid #102dff' : '1px solid #dee2e6',
//                 backgroundColor: assignType === 'teamLeader' ? '#f0f7ff' : 'white',
//                 borderRadius: '10px',
//                 transition: 'all 0.2s ease',
//               }}
//               className="h-100"
//             >
//               <Card.Body className="text-center py-4">
//                 <FaUsers
//                   style={{
//                     fontSize: '2rem',
//                     color: assignType === 'teamLeader' ? '#102dff' : '#6c757d',
//                     marginBottom: '10px',
//                   }}
//                 />
//                 <h6
//                   style={{
//                     fontWeight: '600',
//                     color: assignType === 'teamLeader' ? '#102dff' : '#495057',
//                   }}
//                 >
//                   Assign as Team Leader
//                 </h6>
//                 <small style={{ color: '#6c757d' }}>Assign leads to team leaders only</small>
//               </Card.Body>
//             </Card>
//           </Col>
//         </Row>

//         {/* Select Sales/Team Leader - مع خاصية البحث */}
//         <Form.Group className="mb-4">
//           <Form.Label
//             style={{
//               fontWeight: '600',
//               color: '#495057',
//             }}
//           >
//             Select {assignType === 'teamLeader' ? 'Team Leader' : 'Sales Person'}
//           </Form.Label>
//           <Select
//             options={salesOptions}
//             onChange={onsaleschange}
//             placeholder="Search or choose..."
//             isClearable
//             isSearchable
//             styles={customSelectStyles}
//             menuPortalTarget={document.body} // ✅ عشان يظهر فوق المودال
//             value={salesOptions.find(option => option.value === salesname) || null}
//           />
//           {selectedSalesDataArray.length > 0 && (
//             <div
//               style={{
//                 marginTop: '10px',
//                 padding: '10px',
//                 backgroundColor: '#f8f9ff',
//                 borderRadius: '8px',
//                 borderLeft: '3px solid #102dff',
//               }}
//             >
//               <small style={{ color: '#102dff', fontWeight: 'bold' }}>
//                 Selected: {selectedSalesDataArray[0]?.name}
//               </small>
//               {selectedSalesDataArray[0]?.userlog?.role && (
//                 <small
//                   style={{
//                     color: '#666',
//                     display: 'block',
//                     marginTop: '4px',
//                   }}
//                 >
//                   Role: {selectedSalesDataArray[0]?.userlog?.role}
//                 </small>
//               )}
//             </div>
//           )}
//         </Form.Group>

//         {/* Stage Options */}
//         <h6
//           style={{
//             color: '#495057',
//             fontWeight: '600',
//             marginBottom: '15px',
//           }}
//         >
//           Stage Options
//         </h6>

//         <Row className="mb-3">
//           <Col md={6}>
//             <Form.Check
//               type="radio"
//               id="same-stage"
//               label={
//                 <>
//                   <span style={{ fontWeight: '500' }}>Same Stage</span>
//                   <small className="text-muted d-block">Keep current stage</small>
//                 </>
//               }
//               name="stageOption"
//               value="option1"
//               checked={selectedOption === 'option1'}
//               onChange={(e) => setSelectedOption(e.target.value)}
//             />
//           </Col>

//           <Col md={6}>
//             <Form.Check
//               type="radio"
//               id="change-stage"
//               label={
//                 <>
//                   <span style={{ fontWeight: '500' }}>Change Stage</span>
//                   <small className="text-muted d-block">Select new stage</small>
//                 </>
//               }
//               name="stageOption"
//               value="option2"
//               checked={selectedOption === 'option2'}
//               onChange={(e) => setSelectedOption(e.target.value)}
//             />
//           </Col>
//         </Row>

//         {selectedOption === 'option2' && (
//           <Form.Group className="mb-4">
//             <Form.Select 
//               value={selectedStage?._id || ''} 
//               onChange={stagechange}
//               style={{
//                 borderRadius: '8px',
//                 padding: '10px',
//                 borderColor: '#dee2e6',
//               }}
//             >
//               <option value="">Select Stage</option>
//               {resStagesData.map((stage) => (
//                 <option key={stage._id} value={stage._id}>
//                   {stage.name}
//                 </option>
//               ))}
//             </Form.Select>
//           </Form.Group>
//         )}

//         {/* Options */}
//         <Row className="mb-4">
//           <Col md={6}>
//             <Form.Check
//               type="checkbox"
//               id="clear-history"
//               label={
//                 <span>
//                   <FaHistory className="me-1" style={{ color: '#102dff' }} />
//                   Clear previous comments for this {assignType === 'teamLeader' ? 'team leader' : 'sales'}
//                 </span>
//               }
//               checked={clearHistory}
//               onChange={(e) => setClearHistory(e.target.checked)}
//             />
//           </Col>

//           <Col md={6}>
//             <Form.Check
//               type="checkbox"
//               id="hide-creation"
//               label={
//                 <span>
//                   <FaEyeSlash className="me-1" style={{ color: '#102dff' }} />
//                   Hide creation date
//                 </span>
//               }
//               checked={hideCreationDate}
//               onChange={(e) => setHideCreationDate(e.target.checked)}
//             />
//           </Col>
//         </Row>
//       </Modal.Body>

//       <Modal.Footer 
//         style={{
//           backgroundColor: '#f8f9fa',
//           borderTop: '1px solid #e9ecef',
//           padding: '1rem 1.5rem',
//         }}
//         className="d-flex justify-content-between align-items-center"
//       >
//         <small className="text-muted">
//           <span
//             style={{
//               display: 'inline-block',
//               width: '8px',
//               height: '8px',
//               backgroundColor: '#102dff',
//               borderRadius: '50%',
//               marginRight: '8px',
//             }}
//           />
//           Ready to assign {leadsall.length} lead{leadsall.length !== 1 ? 's' : ''}
//         </small>
//         <div>
//           <Button
//             variant="outline-secondary"
//             onClick={handleClose}
//             className="me-2"
//             style={{ 
//               color: '#6c757d',
//               borderColor: '#dee2e6',
//               borderRadius: '8px',
//               padding: '8px 24px',
//             }}
//           >
//             Close
//           </Button>
//           <Button
//             variant="primary"
//             onClick={senddleedtosalesaction}
//             disabled={sendloading || !salesname || leadsall.length === 0}
//             style={{ 
//               backgroundColor: '#102dff', 
//               borderColor: '#102dff',
//               borderRadius: '8px',
//               padding: '8px 24px',
//               fontWeight: '500',
//             }}
//           >
//             {sendloading ? (
//               <>
//                 <span
//                   className="spinner-border spinner-border-sm me-2"
//                   role="status"
//                   aria-hidden="true"
//                 ></span>
//                 Assigning...
//               </>
//             ) : (
//               `Assign as ${assignType === 'teamLeader' ? 'Team Leader' : 'Salesman'}`
//             )}
//           </Button>
//         </div>
//       </Modal.Footer>
//     </Modal>
//   );
// };






















// 20-5-2026
// import React, { useEffect, useState, useRef } from 'react';
// import { createPortal } from 'react-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
// import { AssignLeadsMarketerAndAdminAction } from '../Redux/Actions/UsersAction';
// import { Notify } from '../Utility/Notify';
// import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';

// /* ─── helpers ────────────────────────────────────────────────────────────── */
// const chunkArray = (array, size) => {
//   const chunked = [];
//   for (let i = 0; i < array.length; i += size) chunked.push(array.slice(i, i + size));
//   return chunked;
// };

// const getInitials = (name = '') =>
//   name.split(' ').filter(Boolean).map(w => w[0]).join('').toUpperCase().slice(0, 2) || '?';

// // simple deterministic avatar colour from name
// const avatarColor = (name = '') => {
//   const colors = [
//     '#C7D2FE','#FDE68A','#A7F3D0','#FBCFE8','#BAE6FD',
//     '#DDD6FE','#FED7AA','#D1FAE5','#E0E7FF','#FCE7F3',
//   ];
//   let h = 0;
//   for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) % colors.length;
//   return colors[h];
// };

// const avatarText = (name = '') => {
//   const colors = [
//     '#4338CA','#92400E','#065F46','#9D174D','#075985',
//     '#5B21B6','#92400E','#064E3B','#312E81','#831843',
//   ];
//   let h = 0;
//   for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) % colors.length;
//   return colors[h];
// };

// /* ─── inline CSS ─────────────────────────────────────────────────────────── */
// const STYLES = `
//   @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');

//   @keyframes alm-in {
//     from { opacity:0; transform:translateY(20px) scale(0.97); }
//     to   { opacity:1; transform:none; }
//   }
//   @keyframes alm-spin { to { transform:rotate(360deg); } }

//   .alm-overlay {
//     position:fixed; inset:0; z-index:99999;
//     display:flex; align-items:center; justify-content:center;
//     background:rgba(15,20,40,0.55);
//     backdrop-filter:blur(6px);
//     padding:16px;
//     font-family:'DM Sans',sans-serif;
//   }

//   .alm-modal {
//     background:#fff;
//     border-radius:20px;
//     width:100%; max-width:640px;
//     max-height:90vh;
//     overflow:hidden;
//     display:flex; flex-direction:column;
//     box-shadow:0 24px 64px rgba(0,0,0,0.18);
//     animation:alm-in 0.28s cubic-bezier(0.34,1.2,0.64,1) both;
//   }

//   /* ── header ── */
//   .alm-header {
//     padding:24px 28px 16px;
//     border-bottom:1px solid #F1F3F9;
//     flex-shrink:0;
//   }
//   .alm-header-top {
//     display:flex; align-items:flex-start; justify-content:space-between;
//   }
//   .alm-title {
//     font-size:22px; font-weight:700; color:#0F172A; margin:0 0 6px; letter-spacing:-0.3px;
//   }
//   .alm-subtitle {
//     display:flex; align-items:center; gap:6px;
//     font-size:13px; color:#64748B; font-weight:500;
//   }
//   .alm-subtitle-dot {
//     width:8px; height:8px; border-radius:50%; background:#1E40AF; flex-shrink:0;
//   }
//   .alm-close {
//     width:34px; height:34px; border-radius:50%;
//     border:1.5px solid #E2E8F0; background:#F8FAFC;
//     display:flex; align-items:center; justify-content:center;
//     cursor:pointer; color:#64748B; flex-shrink:0;
//     transition:all 0.15s;
//   }
//   .alm-close:hover { background:#F1F5F9; color:#0F172A; border-color:#CBD5E1; }

//   /* ── body ── */
//   .alm-body {
//     flex:1; overflow-y:auto; padding:24px 28px;
//     scrollbar-width:thin; scrollbar-color:#CBD5E1 transparent;
//   }
//   .alm-body::-webkit-scrollbar { width:5px; }
//   .alm-body::-webkit-scrollbar-track { background:transparent; }
//   .alm-body::-webkit-scrollbar-thumb { background:#CBD5E1; border-radius:999px; }

//   /* ── section label ── */
//   .alm-section-label {
//     font-size:11px; font-weight:700; letter-spacing:0.1em;
//     color:#94A3B8; text-transform:uppercase; margin:0 0 14px;
//   }

//   /* ── type cards ── */
//   .alm-type-grid { display:grid; grid-template-columns:1fr 1fr; gap:12px; margin-bottom:28px; }
//   .alm-type-card {
//     border:1.5px solid #E2E8F0; border-radius:14px; padding:20px 18px;
//     cursor:pointer; transition:all 0.18s; background:#FAFBFD; position:relative;
//   }
//   .alm-type-card:hover { border-color:#93C5FD; background:#EFF6FF; }
//   .alm-type-card.active { border-color:#1E3A8A; background:#EFF6FF; }
//   .alm-type-check {
//     position:absolute; top:12px; right:12px;
//     width:22px; height:22px; border-radius:50%;
//     background:#1E3A8A; display:flex; align-items:center; justify-content:center;
//   }
//   .alm-type-icon-wrap {
//     width:40px; height:40px; border-radius:10px;
//     display:flex; align-items:center; justify-content:center;
//     margin-bottom:12px;
//   }
//   .alm-type-icon-wrap.active { background:#DBEAFE; }
//   .alm-type-icon-wrap.inactive { background:#F1F5F9; }
//   .alm-type-name {
//     font-size:15px; font-weight:700; color:#0F172A; margin:0 0 4px;
//   }
//   .alm-type-desc { font-size:12px; color:#64748B; line-height:1.5; margin:0; }

//   /* ── search / dropdown ── */
//   .alm-search-wrap {
//     position:relative; margin-bottom:12px;
//   }
//   .alm-search-input {
//     width:100%; padding:14px 44px 14px 44px;
//     border:1.5px solid #E2E8F0; border-radius:12px;
//     font-family:'DM Sans',sans-serif; font-size:14px; color:#0F172A;
//     background:#F8FAFC; outline:none; transition:border-color 0.15s;
//     box-sizing:border-box;
//   }
//   .alm-search-input:focus { border-color:#1E40AF; background:#fff; }
//   .alm-search-input::placeholder { color:#94A3B8; }
//   .alm-search-icon {
//     position:absolute; left:14px; top:50%; transform:translateY(-50%);
//     color:#94A3B8; pointer-events:none;
//   }
//   .alm-search-arrow {
//     position:absolute; right:14px; top:50%; transform:translateY(-50%);
//     color:#94A3B8; pointer-events:none;
//   }

//   /* ── sales list ── */
//   .alm-sales-list {
//     border:1.5px solid #E2E8F0; border-radius:12px;
//     overflow:hidden; margin-bottom:28px; max-height:220px; overflow-y:auto;
//     scrollbar-width:thin; scrollbar-color:#CBD5E1 transparent;
//   }
//   .alm-sales-list::-webkit-scrollbar { width:4px; }
//   .alm-sales-list::-webkit-scrollbar-thumb { background:#CBD5E1; border-radius:4px; }

//   .alm-sales-item {
//     display:flex; align-items:center; gap:12px;
//     padding:14px 16px; cursor:pointer; transition:background 0.12s;
//     border-bottom:1px solid #F1F3F9;
//   }
//   .alm-sales-item:last-child { border-bottom:none; }
//   .alm-sales-item:hover { background:#F8FAFC; }
//   .alm-sales-item.selected { background:#EFF6FF; }

//   .alm-avatar {
//     width:38px; height:38px; border-radius:50%; flex-shrink:0;
//     display:flex; align-items:center; justify-content:center;
//     font-size:13px; font-weight:700; letter-spacing:0.5px;
//   }
//   .alm-sales-info { flex:1; min-width:0; }
//   .alm-sales-name { font-size:14px; font-weight:600; color:#0F172A; }
//   .alm-sales-role { font-size:12px; color:#94A3B8; font-weight:500; }

//   .alm-radio {
//     width:20px; height:20px; border-radius:50%; border:2px solid #CBD5E1;
//     flex-shrink:0; display:flex; align-items:center; justify-content:center;
//     transition:all 0.15s;
//   }
//   .alm-radio.checked {
//     border-color:#1E3A8A; background:#1E3A8A;
//   }
//   .alm-radio.checked::after {
//     content:''; width:8px; height:8px; border-radius:50%; background:#fff;
//   }

//   /* ── bottom two-col ── */
//   .alm-bottom-grid {
//     display:grid; grid-template-columns:1fr 1fr; gap:24px; margin-bottom:8px;
//   }

//   /* ── stage option ── */
//   .alm-stage-option {
//     display:flex; align-items:flex-start; gap:10px;
//     padding:10px 12px; border-radius:10px; cursor:pointer;
//     transition:background 0.12s; margin-bottom:6px;
//   }
//   .alm-stage-option:hover { background:#F8FAFC; }
//   .alm-stage-radio {
//     width:20px; height:20px; border-radius:50%; border:2px solid #CBD5E1;
//     flex-shrink:0; display:flex; align-items:center; justify-content:center;
//     margin-top:1px; transition:all 0.15s;
//   }
//   .alm-stage-radio.checked { border-color:#1E3A8A; background:#1E3A8A; }
//   .alm-stage-radio.checked::after { content:''; width:8px; height:8px; border-radius:50%; background:#fff; }
//   .alm-stage-text-name { font-size:14px; font-weight:600; color:#0F172A; }
//   .alm-stage-text-desc { font-size:12px; color:#94A3B8; margin-top:1px; }

//   .alm-stage-select {
//     width:100%; padding:10px 12px; border:1.5px solid #E2E8F0; border-radius:10px;
//     font-family:'DM Sans',sans-serif; font-size:13px; color:#0F172A;
//     background:#F8FAFC; outline:none; margin-top:8px; cursor:pointer;
//     transition:border-color 0.15s;
//   }
//   .alm-stage-select:focus { border-color:#1E40AF; }

//   /* ── advanced toggles ── */
//   .alm-toggle-row {
//     display:flex; align-items:flex-start; gap:10px;
//     padding:10px 12px; border-radius:10px; cursor:pointer;
//     transition:background 0.12s; margin-bottom:6px;
//   }
//   .alm-toggle-row:hover { background:#F8FAFC; }
//   .alm-checkbox {
//     width:20px; height:20px; border-radius:6px; border:2px solid #CBD5E1;
//     flex-shrink:0; margin-top:1px; display:flex; align-items:center; justify-content:center;
//     transition:all 0.15s;
//   }
//   .alm-checkbox.checked { border-color:#1E3A8A; background:#1E3A8A; }
//   .alm-toggle-name { font-size:14px; font-weight:600; color:#0F172A; }
//   .alm-toggle-desc { font-size:12px; color:#94A3B8; margin-top:1px; }

//   /* ── footer ── */
//   .alm-footer {
//     padding:16px 28px; border-top:1px solid #F1F3F9;
//     display:flex; align-items:center; justify-content:space-between;
//     flex-shrink:0; background:#fff;
//   }
//   .alm-ready-badge {
//     display:flex; align-items:center; gap:8px;
//     background:#EFF6FF; border:1px solid #BFDBFE;
//     padding:8px 14px; border-radius:999px;
//     font-size:13px; font-weight:600; color:#1E40AF;
//   }
//   .alm-footer-btns { display:flex; gap:10px; }
//   .alm-btn-close {
//     padding:10px 22px; border-radius:10px;
//     border:1.5px solid #E2E8F0; background:#fff;
//     font-family:'DM Sans',sans-serif; font-size:14px; font-weight:600;
//     color:#64748B; cursor:pointer; transition:all 0.15s;
//   }
//   .alm-btn-close:hover { background:#F8FAFC; border-color:#CBD5E1; color:#0F172A; }
//   .alm-btn-assign {
//     padding:10px 28px; border-radius:10px; border:none;
//     background:#1E3A8A; color:#fff;
//     font-family:'DM Sans',sans-serif; font-size:14px; font-weight:700;
//     cursor:pointer; transition:all 0.15s; display:flex; align-items:center; gap:8px;
//   }
//   .alm-btn-assign:hover:not(:disabled) { background:#1E40AF; }
//   .alm-btn-assign:disabled { opacity:0.55; cursor:not-allowed; }
//   .alm-spinner-sm {
//     width:15px; height:15px; border:2px solid rgba(255,255,255,0.3);
//     border-top-color:#fff; border-radius:50%; animation:alm-spin 0.7s linear infinite;
//   }
//   .alm-empty { text-align:center; padding:20px; color:#94A3B8; font-size:13px; }
// `;

// /* ─── icons ──────────────────────────────────────────────────────────────── */
// const IcoClose    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
// const IcoSearch   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>;
// const IcoChevron  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 12 15 18 9"/></svg>;
// const IcoCheck    = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>;
// const IcoSales    = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
// const IcoTeam     = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
// const IcoInfo     = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>;

// /* ════════════════════════════════════════════════════════════════════════════
//    COMPONENT
// ════════════════════════════════════════════════════════════════════════════ */
// export const AssignLeadsModal = ({ show, onHide, selectedLeads = [], refreshData }) => {
//   const dispatch = useDispatch();

//   const [assignType,       setAssignType]       = useState('salesman');
//   const [searchQuery,      setSearchQuery]      = useState('');
//   const [salesname,        setSalesname]        = useState('');
//   const [selectedSale,     setSelectedSale]     = useState(null);
//   const [selectedOption,   setSelectedOption]   = useState('option1');
//   const [selectedStage,    setSelectedStage]    = useState(null);
//   const [clearHistory,     setClearHistory]     = useState(false);
//   const [hideCreationDate, setHideCreationDate] = useState(false);
//   const [sendloading,      setSendloading]      = useState(false);
//   const [userlogin,        setUserlogin]        = useState(null);
//   const [transferstorage,  setTransferstorage]  = useState('');

//   const leadsall = React.useMemo(() => {
//     const leads = selectedLeads.length > 0
//       ? selectedLeads
//       : JSON.parse(localStorage.getItem('selectedleeds') || '[]');
//     return leads;
//   }, [show, selectedLeads]);

//   useEffect(() => {
//     setUserlogin(JSON.parse(localStorage.getItem('user') || '{}'));
//     setTransferstorage(localStorage.getItem('action') || '');
//   }, []);

//   useEffect(() => {
//     if (show) {
//       dispatch(Get_All_Sales_Action());
//       dispatch(GetAll_stage_Data());
//     }
//   }, [show, dispatch]);

//   const resSalesData  = useSelector(s => s.AllSales.sales?.data || []);
//   const resStagesData = useSelector(s => s.Allstages.stage?.data || []);
//   const freshStage    = resStagesData.find(st => st.name === 'No Stage');

//   const filteredSales = React.useMemo(() => {
//     const base = assignType === 'teamLeader'
//       ? resSalesData.filter(s => s?.userlog?.role === 'Team Leader')
//       : resSalesData;
//     const q = searchQuery.toLowerCase();
//     return q ? base.filter(s => s.name?.toLowerCase().includes(q) || s.userlog?.role?.toLowerCase().includes(q)) : base;
//   }, [resSalesData, assignType, searchQuery]);

//   const handleClose = () => {
//     setSalesname(''); setSelectedSale(null);
//     setSelectedOption('option1'); setSelectedStage(null);
//     setClearHistory(false); setHideCreationDate(false);
//     setAssignType('salesman'); setSearchQuery('');
//     onHide();
//   };

//   const handleSelectSale = (sale) => {
//     setSalesname(sale._id);
//     setSelectedSale(sale);
//   };

//   const handleSubmit = async () => {
//     if (!salesname)          return Notify('error', 'Please select a sales person', 'error');
//     if (!leadsall.length)    return Notify('error', 'No leads selected', 'error');

//     setSendloading(true);
//     try {
//       const isTeam   = assignType === 'teamLeader';
//       let stageValue = null;

//       if (transferstorage === 'Transfer') {
//         if (!freshStage?._id) { Notify('error', 'Failed. Try Again', 'error'); return; }
//         stageValue = freshStage._id;
//       } else if (selectedOption === 'option2' && selectedStage?._id) {
//         stageValue = selectedStage._id;
//       }

//       for (const chunk of chunkArray(leadsall, 10)) {
//         await Promise.all(chunk.map(leadId =>
//           dispatch(AssignLeadsMarketerAndAdminAction(
//             leadId, userlogin?.data?._id, salesname,
//             clearHistory, stageValue, isTeam, hideCreationDate,
//           ))
//         ));
//       }

//       if (transferstorage === 'Transfer') { localStorage.removeItem('action'); setTransferstorage(''); }
//       Notify('success', `Leads assigned as ${isTeam ? 'Team Leader' : 'Salesman'}`, 'success');
//       handleClose();
//       refreshData?.();
//     } catch (err) {
//       Notify('error', 'Failed to assign leads', 'error');
//     } finally {
//       setSendloading(false);
//     }
//   };

//   if (!show) return null;

//   return createPortal(
//     <>
//       <style>{STYLES}</style>
//       <div className="alm-overlay" onClick={e => { if (e.target === e.currentTarget) handleClose(); }}>
//         <div className="alm-modal">

//           {/* ── Header ── */}
//           <div className="alm-header">
//             <div className="alm-header-top">
//               <div>
//                 <h2 className="alm-title">Assign Leads to Sales</h2>
//                 <div className="alm-subtitle">
//                   <span className="alm-subtitle-dot"/>
//                   Selected Leads: {leadsall.length} Lead{leadsall.length !== 1 ? 's' : ''}
//                 </div>
//               </div>
//               <button className="alm-close" onClick={handleClose}><IcoClose /></button>
//             </div>
//           </div>

//           {/* ── Body ── */}
//           <div className="alm-body">

//             {/* Assignment Type */}
//             <p className="alm-section-label">Assignment Type</p>
//             <div className="alm-type-grid">
//               {/* Salesman */}
//               <div
//                 className={`alm-type-card ${assignType === 'salesman' ? 'active' : ''}`}
//                 onClick={() => { setAssignType('salesman'); setSalesname(''); setSelectedSale(null); }}
//               >
//                 {assignType === 'salesman' && (
//                   <div className="alm-type-check"><IcoCheck /></div>
//                 )}
//                 <div className={`alm-type-icon-wrap ${assignType === 'salesman' ? 'active' : 'inactive'}`}>
//                   <IcoSales style={{ color: assignType === 'salesman' ? '#1E40AF' : '#94A3B8' }} />
//                 </div>
//                 <p className="alm-type-name">Assign as Salesman</p>
//                 <p className="alm-type-desc">Direct assignment to an individual representative for exclusive lead management.</p>
//               </div>

//               {/* Team Leader */}
//               <div
//                 className={`alm-type-card ${assignType === 'teamLeader' ? 'active' : ''}`}
//                 onClick={() => { setAssignType('teamLeader'); setSalesname(''); setSelectedSale(null); }}
//               >
//                 {assignType === 'teamLeader' && (
//                   <div className="alm-type-check"><IcoCheck /></div>
//                 )}
//                 <div className={`alm-type-icon-wrap ${assignType === 'teamLeader' ? 'active' : 'inactive'}`}>
//                   <IcoTeam style={{ color: assignType === 'teamLeader' ? '#1E40AF' : '#94A3B8' }} />
//                 </div>
//                 <p className="alm-type-name">Assign as Team Leader</p>
//                 <p className="alm-type-desc">Assign to a supervisor to oversee lead distribution and monitoring.</p>
//               </div>
//             </div>

//             {/* Select Sales Person */}
//             <p className="alm-section-label">
//               Select {assignType === 'teamLeader' ? 'Team Leader' : 'Sales Person'}
//             </p>

//             <div className="alm-search-wrap">
//               <span className="alm-search-icon"><IcoSearch /></span>
//               <input
//                 className="alm-search-input"
//                 placeholder={`Search for ${assignType === 'teamLeader' ? 'team leaders' : 'sales executives'}...`}
//                 value={searchQuery}
//                 onChange={e => setSearchQuery(e.target.value)}
//               />
//               <span className="alm-search-arrow"><IcoChevron /></span>
//             </div>

//             <div className="alm-sales-list">
//               {filteredSales.length === 0 ? (
//                 <div className="alm-empty">No {assignType === 'teamLeader' ? 'team leaders' : 'sales'} found</div>
//               ) : filteredSales.map(sale => (
//                 <div
//                   key={sale._id}
//                   className={`alm-sales-item ${salesname === sale._id ? 'selected' : ''}`}
//                   onClick={() => handleSelectSale(sale)}
//                 >
//                   <div
//                     className="alm-avatar"
//                     style={{ background: avatarColor(sale.name), color: avatarText(sale.name) }}
//                   >
//                     {getInitials(sale.name)}
//                   </div>
//                   <div className="alm-sales-info">
//                     <div className="alm-sales-name">{sale.name}</div>
//                     <div className="alm-sales-role">({sale.userlog?.role?.toUpperCase() || 'SALES'})</div>
//                   </div>
//                   <div className={`alm-radio ${salesname === sale._id ? 'checked' : ''}`} />
//                 </div>
//               ))}
//             </div>

//             {/* Bottom two-col */}
//             <div className="alm-bottom-grid">

//               {/* Stage Options */}
//               <div>
//                 <p className="alm-section-label">Stage Options</p>
//                 <div
//                   className="alm-stage-option"
//                   onClick={() => setSelectedOption('option1')}
//                 >
//                   <div className={`alm-stage-radio ${selectedOption === 'option1' ? 'checked' : ''}`} />
//                   <div>
//                     <div className="alm-stage-text-name">Same Stage</div>
//                     <div className="alm-stage-text-desc">Keep current stage</div>
//                   </div>
//                 </div>
//                 <div
//                   className="alm-stage-option"
//                   onClick={() => setSelectedOption('option2')}
//                 >
//                   <div className={`alm-stage-radio ${selectedOption === 'option2' ? 'checked' : ''}`} />
//                   <div>
//                     <div className="alm-stage-text-name">Change Stage</div>
//                     <div className="alm-stage-text-desc">Select new stage</div>
//                   </div>
//                 </div>
//                 {selectedOption === 'option2' && (
//                   <select
//                     className="alm-stage-select"
//                     value={selectedStage?._id || ''}
//                     onChange={e => setSelectedStage(resStagesData.find(st => st._id === e.target.value) || null)}
//                   >
//                     <option value="">Select Stage</option>
//                     {resStagesData.map(st => (
//                       <option key={st._id} value={st._id}>{st.name}</option>
//                     ))}
//                   </select>
//                 )}
//               </div>

//               {/* Advanced Settings */}
//               <div>
//                 <p className="alm-section-label">Advanced Settings</p>
//                 <div className="alm-toggle-row" onClick={() => setClearHistory(v => !v)}>
//                   <div className={`alm-checkbox ${clearHistory ? 'checked' : ''}`}>
//                     {clearHistory && <IcoCheck />}
//                   </div>
//                   <div>
//                     <div className="alm-toggle-name">Clear previous comments</div>
//                     <div className="alm-toggle-desc">for this {assignType === 'teamLeader' ? 'team leader' : 'sales'}</div>
//                   </div>
//                 </div>
//                 <div className="alm-toggle-row" onClick={() => setHideCreationDate(v => !v)}>
//                   <div className={`alm-checkbox ${hideCreationDate ? 'checked' : ''}`}>
//                     {hideCreationDate && <IcoCheck />}
//                   </div>
//                   <div>
//                     <div className="alm-toggle-name">Hide creation date</div>
//                     <div className="alm-toggle-desc">from sales person view</div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//           </div>{/* /body */}

//           {/* ── Footer ── */}
//           <div className="alm-footer">
//             <div className="alm-ready-badge">
//               <IcoInfo />
//               READY TO ASSIGN {leadsall.length} LEAD{leadsall.length !== 1 ? 'S' : ''}
//             </div>
//             <div className="alm-footer-btns">
//               <button className="alm-btn-close" onClick={handleClose}>Close</button>
//               <button
//                 className="alm-btn-assign"
//                 onClick={handleSubmit}
//                 disabled={sendloading || !salesname || !leadsall.length}
//               >
//                 {sendloading
//                   ? <><div className="alm-spinner-sm"/>Assigning…</>
//                   : `Assign as ${assignType === 'teamLeader' ? 'Team Leader' : 'Salesman'}`}
//               </button>
//             </div>
//           </div>

//         </div>
//       </div>
//     </>,
//     document.body
//   );
// };















// after 20-5-2026
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
import { AssignLeadsMarketerAndAdminAction } from '../Redux/Actions/UsersAction';
import { Notify } from '../Utility/Notify';
import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';
import baseurl from '../Api/BaseUrl';

/* ─── helpers ─────────────────────────────────────────────────────── */
const chunkArray = (array, size) => {
  const chunked = [];
  for (let i = 0; i < array.length; i += size) chunked.push(array.slice(i, i + size));
  return chunked;
};
const getInitials  = (name = '') => name.split(' ').filter(Boolean).map(w => w[0]).join('').toUpperCase().slice(0, 2) || '?';
const avatarColor  = (name = '') => { const c=['#C7D2FE','#FDE68A','#A7F3D0','#FBCFE8','#BAE6FD','#DDD6FE','#FED7AA','#D1FAE5','#E0E7FF','#FCE7F3']; let h=0; for(let i=0;i<name.length;i++) h=(h*31+name.charCodeAt(i))%c.length; return c[h]; };
const avatarText   = (name = '') => { const c=['#4338CA','#92400E','#065F46','#9D174D','#075985','#5B21B6','#92400E','#064E3B','#312E81','#831843']; let h=0; for(let i=0;i<name.length;i++) h=(h*31+name.charCodeAt(i))%c.length; return c[h]; };

/* ─── styles ──────────────────────────────────────────────────────── */
const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');
  @keyframes alm-in  { from{opacity:0;transform:translateY(20px) scale(0.97)} to{opacity:1;transform:none} }
  @keyframes alm-spin { to{transform:rotate(360deg)} }

  .alm-overlay {
    position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;
    background:rgba(15,20,40,0.55);backdrop-filter:blur(6px);padding:16px;font-family:'DM Sans',sans-serif;
  }
  .alm-modal {
    background:#fff;border-radius:20px;width:100%;max-width:640px;max-height:90vh;
    overflow:hidden;display:flex;flex-direction:column;
    box-shadow:0 24px 64px rgba(0,0,0,0.18);animation:alm-in 0.28s cubic-bezier(0.34,1.2,0.64,1) both;
  }
  .alm-header { padding:24px 28px 16px;border-bottom:1px solid #F1F3F9;flex-shrink:0; }
  .alm-header-top { display:flex;align-items:flex-start;justify-content:space-between; }
  .alm-title { font-size:22px;font-weight:700;color:#0F172A;margin:0 0 6px;letter-spacing:-0.3px; }
  .alm-subtitle { display:flex;align-items:center;gap:6px;font-size:13px;color:#64748B;font-weight:500; }
  .alm-subtitle-dot { width:8px;height:8px;border-radius:50%;background:#1E40AF;flex-shrink:0; }
  .alm-close {
    width:34px;height:34px;border-radius:50%;border:1.5px solid #E2E8F0;background:#F8FAFC;
    display:flex;align-items:center;justify-content:center;cursor:pointer;color:#64748B;flex-shrink:0;transition:all 0.15s;
  }
  .alm-close:hover { background:#F1F5F9;color:#0F172A;border-color:#CBD5E1; }
  .alm-body {
    flex:1;overflow-y:auto;padding:24px 28px;
    scrollbar-width:thin;scrollbar-color:#CBD5E1 transparent;
  }
  .alm-body::-webkit-scrollbar{width:5px}
  .alm-body::-webkit-scrollbar-thumb{background:#CBD5E1;border-radius:999px}
  .alm-section-label {
    font-size:11px;font-weight:700;letter-spacing:0.1em;
    color:#94A3B8;text-transform:uppercase;margin:0 0 14px;
  }
  .alm-toggle-bar {
    display:flex;align-items:center;justify-content:space-between;
    background:#F8FAFC;border:1.5px solid #E2E8F0;border-radius:14px;
    padding:14px 18px;margin-bottom:24px;cursor:pointer;transition:all 0.18s;user-select:none;
  }
  .alm-toggle-bar:hover { border-color:#93C5FD;background:#EFF6FF; }
  .alm-toggle-bar.on    { border-color:#1E3A8A;background:#EFF6FF; }
  .alm-toggle-bar-left  { display:flex;align-items:center;gap:12px; }
  .alm-toggle-bar-icon  {
    width:38px;height:38px;border-radius:10px;display:flex;align-items:center;
    justify-content:center;background:#E0E7FF;flex-shrink:0;transition:background 0.18s;
  }
  .alm-toggle-bar.on .alm-toggle-bar-icon { background:#DBEAFE; }
  .alm-toggle-bar-title { font-size:14px;font-weight:700;color:#0F172A; }
  .alm-toggle-bar-desc  { font-size:12px;color:#64748B;margin-top:2px; }
  .alm-switch {
    width:44px;height:24px;border-radius:999px;background:#CBD5E1;
    position:relative;transition:background 0.2s;flex-shrink:0;
  }
  .alm-switch.on { background:#1E3A8A; }
  .alm-switch::after {
    content:'';position:absolute;top:3px;left:3px;width:18px;height:18px;
    border-radius:50%;background:#fff;transition:transform 0.2s;box-shadow:0 1px 4px rgba(0,0,0,0.18);
  }
  .alm-switch.on::after { transform:translateX(20px); }
  .alm-type-grid { display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:28px; }
  .alm-type-card {
    border:1.5px solid #E2E8F0;border-radius:14px;padding:20px 18px;
    cursor:pointer;transition:all 0.18s;background:#FAFBFD;position:relative;
  }
  .alm-type-card:hover  { border-color:#93C5FD;background:#EFF6FF; }
  .alm-type-card.active { border-color:#1E3A8A;background:#EFF6FF; }
  .alm-type-check {
    position:absolute;top:12px;right:12px;width:22px;height:22px;border-radius:50%;
    background:#1E3A8A;display:flex;align-items:center;justify-content:center;
  }
  .alm-type-icon-wrap { width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;margin-bottom:12px; }
  .alm-type-icon-wrap.active   { background:#DBEAFE; }
  .alm-type-icon-wrap.inactive { background:#F1F5F9; }
  .alm-type-name { font-size:15px;font-weight:700;color:#0F172A;margin:0 0 4px; }
  .alm-type-desc { font-size:12px;color:#64748B;line-height:1.5;margin:0; }
  .alm-random-banner {
    background:#EFF6FF;border:1.5px solid #BFDBFE;border-radius:12px;
    padding:12px 16px;margin-bottom:20px;font-size:13px;color:#1E40AF;
    font-weight:500;display:flex;align-items:center;gap:8px;
  }
  .alm-search-wrap { position:relative;margin-bottom:12px; }
  .alm-search-input {
    width:100%;padding:14px 44px;border:1.5px solid #E2E8F0;border-radius:12px;
    font-family:'DM Sans',sans-serif;font-size:14px;color:#0F172A;
    background:#F8FAFC;outline:none;transition:border-color 0.15s;box-sizing:border-box;
  }
  .alm-search-input:focus { border-color:#1E40AF;background:#fff; }
  .alm-search-input::placeholder { color:#94A3B8; }
  .alm-search-icon  { position:absolute;left:14px;top:50%;transform:translateY(-50%);color:#94A3B8;pointer-events:none; }
  .alm-search-arrow { position:absolute;right:14px;top:50%;transform:translateY(-50%);color:#94A3B8;pointer-events:none; }
  .alm-sales-list {
    border:1.5px solid #E2E8F0;border-radius:12px;overflow:hidden;
    margin-bottom:28px;max-height:220px;overflow-y:auto;
    scrollbar-width:thin;scrollbar-color:#CBD5E1 transparent;
  }
  .alm-sales-list::-webkit-scrollbar{width:4px}
  .alm-sales-list::-webkit-scrollbar-thumb{background:#CBD5E1;border-radius:4px}
  .alm-sales-item {
    display:flex;align-items:center;gap:12px;padding:14px 16px;
    cursor:pointer;transition:background 0.12s;border-bottom:1px solid #F1F3F9;
  }
  .alm-sales-item:last-child { border-bottom:none; }
  .alm-sales-item:hover    { background:#F8FAFC; }
  .alm-sales-item.selected { background:#EFF6FF; }
  .alm-avatar { width:38px;height:38px;border-radius:50%;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;letter-spacing:0.5px; }
  .alm-sales-info { flex:1;min-width:0; }
  .alm-sales-name { font-size:14px;font-weight:600;color:#0F172A; }
  .alm-sales-role { font-size:12px;color:#94A3B8;font-weight:500; }
  .alm-radio { width:20px;height:20px;border-radius:50%;border:2px solid #CBD5E1;flex-shrink:0;display:flex;align-items:center;justify-content:center;transition:all 0.15s; }
  .alm-radio.checked { border-color:#1E3A8A;background:#1E3A8A; }
  .alm-radio.checked::after { content:'';width:8px;height:8px;border-radius:50%;background:#fff; }
  .alm-multi-check { width:20px;height:20px;border-radius:6px;border:2px solid #CBD5E1;flex-shrink:0;display:flex;align-items:center;justify-content:center;transition:all 0.15s; }
  .alm-multi-check.checked { border-color:#1E3A8A;background:#1E3A8A; }
  .alm-selected-badge { display:inline-flex;align-items:center;gap:4px;background:#DBEAFE;color:#1E3A8A;font-size:11px;font-weight:700;border-radius:999px;padding:3px 10px;margin-bottom:10px; }
  .alm-bottom-grid { display:grid;grid-template-columns:1fr 1fr;gap:24px;margin-bottom:8px; }
  .alm-stage-option { display:flex;align-items:flex-start;gap:10px;padding:10px 12px;border-radius:10px;cursor:pointer;transition:background 0.12s;margin-bottom:6px; }
  .alm-stage-option:hover { background:#F8FAFC; }
  .alm-stage-radio { width:20px;height:20px;border-radius:50%;border:2px solid #CBD5E1;flex-shrink:0;display:flex;align-items:center;justify-content:center;margin-top:1px;transition:all 0.15s; }
  .alm-stage-radio.checked { border-color:#1E3A8A;background:#1E3A8A; }
  .alm-stage-radio.checked::after { content:'';width:8px;height:8px;border-radius:50%;background:#fff; }
  .alm-stage-text-name { font-size:14px;font-weight:600;color:#0F172A; }
  .alm-stage-text-desc { font-size:12px;color:#94A3B8;margin-top:1px; }
  .alm-stage-select { width:100%;padding:10px 12px;border:1.5px solid #E2E8F0;border-radius:10px;font-family:'DM Sans',sans-serif;font-size:13px;color:#0F172A;background:#F8FAFC;outline:none;margin-top:8px;cursor:pointer;transition:border-color 0.15s; }
  .alm-stage-select:focus { border-color:#1E40AF; }
  .alm-toggle-row { display:flex;align-items:flex-start;gap:10px;padding:10px 12px;border-radius:10px;cursor:pointer;transition:background 0.12s;margin-bottom:6px; }
  .alm-toggle-row:hover { background:#F8FAFC; }
  .alm-checkbox { width:20px;height:20px;border-radius:6px;border:2px solid #CBD5E1;flex-shrink:0;margin-top:1px;display:flex;align-items:center;justify-content:center;transition:all 0.15s; }
  .alm-checkbox.checked { border-color:#1E3A8A;background:#1E3A8A; }
  .alm-toggle-name { font-size:14px;font-weight:600;color:#0F172A; }
  .alm-toggle-desc { font-size:12px;color:#94A3B8;margin-top:1px; }
  .alm-footer { padding:16px 28px;border-top:1px solid #F1F3F9;display:flex;align-items:center;justify-content:space-between;flex-shrink:0;background:#fff; }
  .alm-ready-badge { display:flex;align-items:center;gap:8px;background:#EFF6FF;border:1px solid #BFDBFE;padding:8px 14px;border-radius:999px;font-size:13px;font-weight:600;color:#1E40AF; }
  .alm-footer-btns { display:flex;gap:10px; }
  .alm-btn-close { padding:10px 22px;border-radius:10px;border:1.5px solid #E2E8F0;background:#fff;font-family:'DM Sans',sans-serif;font-size:14px;font-weight:600;color:#64748B;cursor:pointer;transition:all 0.15s; }
  .alm-btn-close:hover { background:#F8FAFC;border-color:#CBD5E1;color:#0F172A; }
  .alm-btn-assign { padding:10px 28px;border-radius:10px;border:none;background:#1E3A8A;color:#fff;font-family:'DM Sans',sans-serif;font-size:14px;font-weight:700;cursor:pointer;transition:all 0.15s;display:flex;align-items:center;gap:8px; }
  .alm-btn-assign:hover:not(:disabled) { background:#1E40AF; }
  .alm-btn-assign:disabled { opacity:0.55;cursor:not-allowed; }
  .alm-spinner-sm { width:15px;height:15px;border:2px solid rgba(255,255,255,0.3);border-top-color:#fff;border-radius:50%;animation:alm-spin 0.7s linear infinite; }
  .alm-empty { text-align:center;padding:20px;color:#94A3B8;font-size:13px; }
`;

/* ─── icons ───────────────────────────────────────────────────────── */
const IcoClose   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IcoSearch  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>;
const IcoChevron = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 12 15 18 9"/></svg>;
const IcoCheck   = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>;
const IcoSales   = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
const IcoTeam    = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
const IcoInfo    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>;
const IcoRandom  = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="16 3 21 3 21 8"/><line x1="4" y1="20" x2="21" y2="3"/><polyline points="21 16 21 21 16 21"/><line x1="15" y1="15" x2="21" y2="21"/></svg>;

/* ════════════════════════════════════════════════════════════════════
   COMPONENT
════════════════════════════════════════════════════════════════════ */
export const AssignLeadsModal = ({ show, onHide, selectedLeads = [], refreshData }) => {
  const dispatch = useDispatch();

  const [isRandomAssign,   setIsRandomAssign]   = useState(false);
  const [assignType,       setAssignType]       = useState('salesman');
  const [searchQuery,      setSearchQuery]      = useState('');
  const [salesname,        setSalesname]        = useState('');
  const [selectedSale,     setSelectedSale]     = useState(null);
  const [selectedSalesIds, setSelectedSalesIds] = useState([]);
  const [selectedOption,   setSelectedOption]   = useState('option1');
  const [selectedStage,    setSelectedStage]    = useState(null);
  const [clearHistory,     setClearHistory]     = useState(false);
  const [hideCreationDate, setHideCreationDate] = useState(false);
  const [hideSalesName,    setHideSalesName]    = useState(false); // ← جديد
  const [sendloading,      setSendloading]      = useState(false);
  const [userlogin,        setUserlogin]        = useState(null);
  const [transferstorage,  setTransferstorage]  = useState('');

  const leadsall = React.useMemo(() => {
    return selectedLeads.length > 0
      ? selectedLeads
      : JSON.parse(localStorage.getItem('selectedleeds') || '[]');
  }, [show, selectedLeads]);

  useEffect(() => {
    setUserlogin(JSON.parse(localStorage.getItem('user') || '{}'));
    setTransferstorage(localStorage.getItem('action') || '');
  }, []);

  useEffect(() => {
    if (show) { dispatch(Get_All_Sales_Action()); dispatch(GetAll_stage_Data()); }
  }, [show, dispatch]);

  const resSalesData  = useSelector(s => s.AllSales.sales?.data || []);
  const resStagesData = useSelector(s => s.Allstages.stage?.data || []);
  const freshStage    = resStagesData.find(st => st.name === 'No Stage');

  const filteredSales = React.useMemo(() => {
    const base = assignType === 'teamLeader'
      ? resSalesData.filter(s => s?.userlog?.role === 'Team Leader')
      : resSalesData;
    const q = searchQuery.toLowerCase();
    return q ? base.filter(s => s.name?.toLowerCase().includes(q) || s.userlog?.role?.toLowerCase().includes(q)) : base;
  }, [resSalesData, assignType, searchQuery]);

  const handleClose = () => {
    setSalesname(''); setSelectedSale(null); setSelectedSalesIds([]);
    setSelectedOption('option1'); setSelectedStage(null);
    setClearHistory(false); setHideCreationDate(false); setHideSalesName(false); // ← reset
    setAssignType('salesman'); setSearchQuery('');
    setIsRandomAssign(false);
    onHide();
  };

  const handleSelectSale = (sale) => { setSalesname(sale._id); setSelectedSale(sale); };

  const handleToggleSale = (sale) => {
    setSelectedSalesIds(prev =>
      prev.includes(sale._id) ? prev.filter(id => id !== sale._id) : [...prev, sale._id]
    );
  };

  const handleSubmit = async () => {
    if (!leadsall.length) return Notify('error', 'No leads selected', 'error');
    setSendloading(true);
    try {

      /* ══ RANDOM ASSIGN ══ */
      if (isRandomAssign) {
        if (selectedSalesIds.length === 0)
          return Notify('error', 'Please select at least one sales person', 'error');
        if (leadsall.length < 10)
          return Notify('error', 'Minimum 10 leads required for Random Assign', 'error');

        let stageValue = null;
        if (transferstorage === 'Transfer') {
          if (!freshStage?._id) { Notify('error', 'Failed. Try Again', 'error'); return; }
          stageValue = freshStage._id;
        } else if (selectedOption === 'option2' && selectedStage?._id) {
          stageValue = selectedStage._id;
        }

        const { data } = await baseurl.put(
          `api/v1/users/leads/bulk-assign/${userlogin?.data?._id}`,
          {
            leadIds:                     leadsall,
            salesIds:                    selectedSalesIds,
            stage:                       stageValue,
            assigntype:                  assignType === 'teamLeader',
            clearHistory:                clearHistory ? 'true' : 'false',
            resetcreationdate:           hideCreationDate,
            hidesalesnameonleadcomments: hideSalesName, // ← جديد
          }
        );

        if (transferstorage === 'Transfer') { localStorage.removeItem('action'); setTransferstorage(''); }
        const summaryText = data.summary?.map(s => `${s.salesName}: ${s.assigned}`).join(' · ') || '';
        Notify('success', `${leadsall.length} leads distributed randomly. ${summaryText}`, 'success');
        handleClose(); refreshData?.();
        return;
      }

      /* ══ SPECIFIC ASSIGN ══ */
      if (!salesname) return Notify('error', 'Please select a sales person', 'error');
      const isTeam = assignType === 'teamLeader';
      let stageValue = null;
      if (transferstorage === 'Transfer') {
        if (!freshStage?._id) { Notify('error', 'Failed. Try Again', 'error'); return; }
        stageValue = freshStage._id;
      } else if (selectedOption === 'option2' && selectedStage?._id) {
        stageValue = selectedStage._id;
      }
      for (const chunk of chunkArray(leadsall, 10)) {
        await Promise.all(chunk.map(leadId =>
          dispatch(AssignLeadsMarketerAndAdminAction(
            leadId, userlogin?.data?._id, salesname,
            clearHistory, stageValue, isTeam, hideCreationDate, hideSalesName, // ← جديد
          ))
        ));
      }
      if (transferstorage === 'Transfer') { localStorage.removeItem('action'); setTransferstorage(''); }
      Notify('success', `Leads assigned as ${isTeam ? 'Team Leader' : 'Salesman'}`, 'success');
      handleClose(); refreshData?.();

    } catch (err) {
      Notify('error', err?.response?.data?.message || 'Failed to assign leads', 'error');
    } finally {
      setSendloading(false);
    }
  };

  const canSubmit = isRandomAssign
    ? selectedSalesIds.length > 0 && leadsall.length >= 10
    : !!salesname && leadsall.length > 0;

  /* ── Assignment Type Cards ── */
  const AssignmentTypeCards = () => (
    <>
      <p className="alm-section-label">Assignment Type</p>
      <div className="alm-type-grid">
        <div
          className={`alm-type-card ${assignType === 'salesman' ? 'active' : ''}`}
          onClick={() => { setAssignType('salesman'); setSalesname(''); setSelectedSale(null); setSelectedSalesIds([]); }}
        >
          {assignType === 'salesman' && <div className="alm-type-check"><IcoCheck /></div>}
          <div className={`alm-type-icon-wrap ${assignType === 'salesman' ? 'active' : 'inactive'}`}>
            <IcoSales style={{ color: assignType === 'salesman' ? '#1E40AF' : '#94A3B8' }} />
          </div>
          <p className="alm-type-name">Assign as Salesman</p>
          <p className="alm-type-desc">Direct assignment to an individual representative for exclusive lead management.</p>
        </div>
        <div
          className={`alm-type-card ${assignType === 'teamLeader' ? 'active' : ''}`}
          onClick={() => { setAssignType('teamLeader'); setSalesname(''); setSelectedSale(null); setSelectedSalesIds([]); }}
        >
          {assignType === 'teamLeader' && <div className="alm-type-check"><IcoCheck /></div>}
          <div className={`alm-type-icon-wrap ${assignType === 'teamLeader' ? 'active' : 'inactive'}`}>
            <IcoTeam style={{ color: assignType === 'teamLeader' ? '#1E40AF' : '#94A3B8' }} />
          </div>
          <p className="alm-type-name">Assign as Team Leader</p>
          <p className="alm-type-desc">Assign to a supervisor to oversee lead distribution and monitoring.</p>
        </div>
      </div>
    </>
  );

  if (!show) return null;

  return createPortal(
    <>
      <style>{STYLES}</style>
      <div className="alm-overlay" onClick={e => { if (e.target === e.currentTarget) handleClose(); }}>
        <div className="alm-modal">

          {/* Header */}
          <div className="alm-header">
            <div className="alm-header-top">
              <div>
                <h2 className="alm-title">Assign Leads to Sales</h2>
                <div className="alm-subtitle">
                  <span className="alm-subtitle-dot"/>
                  Selected Leads: {leadsall.length} Lead{leadsall.length !== 1 ? 's' : ''}
                </div>
              </div>
              <button className="alm-close" onClick={handleClose}><IcoClose /></button>
            </div>
          </div>

          {/* Body */}
          <div className="alm-body">

            {/* Toggle Bar */}
            <div
              className={`alm-toggle-bar ${isRandomAssign ? 'on' : ''}`}
              onClick={() => { setIsRandomAssign(v => !v); setSalesname(''); setSelectedSale(null); setSelectedSalesIds([]); }}
            >
              <div className="alm-toggle-bar-left">
                <div className="alm-toggle-bar-icon">
                  <IcoRandom style={{ color: isRandomAssign ? '#1E40AF' : '#6366F1' }} />
                </div>
                <div>
                  <div className="alm-toggle-bar-title">{isRandomAssign ? 'Random Assign' : 'Specific Assign'}</div>
                  <div className="alm-toggle-bar-desc">
                    {isRandomAssign
                      ? 'Leads will be distributed evenly & randomly across selected sales'
                      : 'Assign all leads to one specific sales person'}
                  </div>
                </div>
              </div>
              <div className={`alm-switch ${isRandomAssign ? 'on' : ''}`} />
            </div>

            {/* warning */}
            {isRandomAssign && leadsall.length < 10 && (
              <div className="alm-random-banner">
                <IcoInfo />
                Random Assign requires at least 10 leads. You have {leadsall.length}.
              </div>
            )}

            {/* Assignment Type */}
            <AssignmentTypeCards />

            {/* Sales List Label */}
            <p className="alm-section-label">
              {isRandomAssign
                ? 'Select Sales Persons (multi-select)'
                : `Select ${assignType === 'teamLeader' ? 'Team Leader' : 'Sales Person'}`}
            </p>

            {isRandomAssign && selectedSalesIds.length > 0 && (
              <div className="alm-selected-badge"><IcoCheck />{selectedSalesIds.length} selected</div>
            )}

            <div className="alm-search-wrap">
              <span className="alm-search-icon"><IcoSearch /></span>
              <input
                className="alm-search-input"
                placeholder={`Search for ${assignType === 'teamLeader' ? 'team leaders' : 'sales executives'}...`}
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
              />
              <span className="alm-search-arrow"><IcoChevron /></span>
            </div>

            <div className="alm-sales-list">
              {filteredSales.length === 0 ? (
                <div className="alm-empty">No {assignType === 'teamLeader' ? 'team leaders' : 'sales'} found</div>
              ) : filteredSales.map(sale => {
                const isSelected = isRandomAssign ? selectedSalesIds.includes(sale._id) : salesname === sale._id;
                return (
                  <div
                    key={sale._id}
                    className={`alm-sales-item ${isSelected ? 'selected' : ''}`}
                    onClick={() => isRandomAssign ? handleToggleSale(sale) : handleSelectSale(sale)}
                  >
                    <div className="alm-avatar" style={{ background: avatarColor(sale.name), color: avatarText(sale.name) }}>
                      {getInitials(sale.name)}
                    </div>
                    <div className="alm-sales-info">
                      <div className="alm-sales-name">{sale.name}</div>
                      <div className="alm-sales-role">({sale.userlog?.role?.toUpperCase() || 'SALES'})</div>
                    </div>
                    {isRandomAssign ? (
                      <div className={`alm-multi-check ${isSelected ? 'checked' : ''}`}>{isSelected && <IcoCheck />}</div>
                    ) : (
                      <div className={`alm-radio ${isSelected ? 'checked' : ''}`} />
                    )}
                  </div>
                );
              })}
            </div>

            {/* Bottom grid */}
            <div className="alm-bottom-grid">
              {/* Stage Options */}
              <div>
                <p className="alm-section-label">Stage Options</p>
                <div className="alm-stage-option" onClick={() => setSelectedOption('option1')}>
                  <div className={`alm-stage-radio ${selectedOption === 'option1' ? 'checked' : ''}`} />
                  <div><div className="alm-stage-text-name">Same Stage</div><div className="alm-stage-text-desc">Keep current stage</div></div>
                </div>
                <div className="alm-stage-option" onClick={() => setSelectedOption('option2')}>
                  <div className={`alm-stage-radio ${selectedOption === 'option2' ? 'checked' : ''}`} />
                  <div><div className="alm-stage-text-name">Change Stage</div><div className="alm-stage-text-desc">Select new stage</div></div>
                </div>
                {selectedOption === 'option2' && (
                  <select className="alm-stage-select" value={selectedStage?._id || ''} onChange={e => setSelectedStage(resStagesData.find(st => st._id === e.target.value) || null)}>
                    <option value="">Select Stage</option>
                    {resStagesData.map(st => <option key={st._id} value={st._id}>{st.name}</option>)}
                  </select>
                )}
              </div>

              {/* Advanced Settings */}
              <div>
                <p className="alm-section-label">Advanced Settings</p>

                <div className="alm-toggle-row" onClick={() => setClearHistory(v => !v)}>
                  <div className={`alm-checkbox ${clearHistory ? 'checked' : ''}`}>{clearHistory && <IcoCheck />}</div>
                  <div>
                    <div className="alm-toggle-name">Clear previous comments</div>
                    <div className="alm-toggle-desc">for this {assignType === 'teamLeader' ? 'team leader' : 'sales'}</div>
                  </div>
                </div>

                <div className="alm-toggle-row" onClick={() => setHideCreationDate(v => !v)}>
                  <div className={`alm-checkbox ${hideCreationDate ? 'checked' : ''}`}>{hideCreationDate && <IcoCheck />}</div>
                  <div>
                    <div className="alm-toggle-name">Hide creation date</div>
                    <div className="alm-toggle-desc">from sales person view</div>
                  </div>
                </div>

                {/* ── جديد ── */}
                <div className="alm-toggle-row" onClick={() => setHideSalesName(v => !v)}>
                  <div className={`alm-checkbox ${hideSalesName ? 'checked' : ''}`}>{hideSalesName && <IcoCheck />}</div>
                  <div>
                    <div className="alm-toggle-name">Hide sales name</div>
                    <div className="alm-toggle-desc">on lead comments view</div>
                  </div>
                </div>

              </div>
            </div>

          </div>

          {/* Footer */}
          <div className="alm-footer">
            <div className="alm-ready-badge">
              <IcoInfo />
              READY TO ASSIGN {leadsall.length} LEAD{leadsall.length !== 1 ? 'S' : ''}
            </div>
            <div className="alm-footer-btns">
              <button className="alm-btn-close" onClick={handleClose}>Close</button>
              <button className="alm-btn-assign" onClick={handleSubmit} disabled={sendloading || !canSubmit}>
                {sendloading ? (
                  <><div className="alm-spinner-sm"/>Assigning…</>
                ) : isRandomAssign ? (
                  `Random Assign (${selectedSalesIds.length} sales)`
                ) : (
                  `Assign as ${assignType === 'teamLeader' ? 'Team Leader' : 'Salesman'}`
                )}
              </button>
            </div>
          </div>

        </div>
      </div>
    </>,
    document.body
  );
};

